<template slot="rctis" slot-scope="props">
  <tr
    style="cursor: pointer"
    :class="[ updated ? 'blue lighten-5' : '', 
    created ? 'green lighten-5' : '', 
    credit ? 'red lighten-5' : '' , 
    closed ? 'grey lighten-4' : '',
    approved ? 'approved-border': '',
    sent ? 'sent-border': '']"
    @click="editDialog = true"
  >
    <td @click.stop>
      <v-checkbox v-model="selected" :color="$store.state.global.pages.rcti.color" hide-details></v-checkbox>
    </td>

    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'count'">{{ getObjectPath(header.value, rcti).length || "-" }}</span>

      <span
        v-if="header.type == 'date'"
      >{{ makeShortDate(getObjectPath(header.value, rcti)) || "-" }}</span>
      <span v-if="header.type == 'time'">{{ makeTime(getObjectPath(header.value, rcti)) || "-" }}</span>
      <span
        v-if="header.type == 'num'"
      >{{ displayDecimal(getObjectPath(header.value, rcti),header.decimals) || "-" }}</span>
      <span
        v-if="header.type == 'curr' "
      >{{ !!getObjectPath(header.value, rcti) ? `$ ${displayDecimal(getObjectPath(header.value, rcti),header.decimals)}` : "-" || "" }}</span>
      <span v-if="header.type == 'text'">{{ getObjectPath(header.value, rcti) || "-" }}</span>

      <!--ACTIONS COLUMN -->
      <div
        v-if="header.type == 'action' && userAuthClass"
        class="justify-center layout px-0"
        @click.stop
      >
        <v-tooltip left>
          <v-btn slot="activator" icon @click="editRcti">
            <v-icon
              :color="rcti.statDecConfirmed == 'CONFIRMED' ? 'green lighten-2' : rcti.statDecConfirmed == 'REVIEW' ? 'orange lighten-2' : 'grey'"
            >file_copy</v-icon>
          </v-btn>
          <span>The Stat Declaration for this RCTI is {{rcti.statDecConfirmed || 'NOT SET'}}</span>
        </v-tooltip>

        <!-- TRIP OPTIONS MENU -->
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <!-- <basic-list-tile title="RCTI Summary" :color="$store.state.global.pages.rcti.color"
                        :icon="$store.state.global.pages.rcti.icon"
                        :onClick="viewSummaryDialog">
            </basic-list-tile>-->
            <basic-list-tile title="Edit" icon="edit" :onClick="editRcti"></basic-list-tile>
            <basic-list-tile
              v-if="!closed"
              title="Add Adjustment"
              icon="add_circle"
              :onClick="addAdjustment"
            ></basic-list-tile>
            <v-divider inset></v-divider>
            <basic-list-tile
              v-if="!closed"
              color="red lighten-3"
              title="Delete"
              icon="delete"
              :onClick="deleteRcti"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </div>
      <!--END ACTIONS COLUMN -->
    </td>
    <!-- END CELLS -->

    <!--  DIALOGS  -->
    <!-- Rcti edit dialog -->
    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-rcti @close="editDialog = false" :rcti="rcti" :closed="closed"></edit-rcti>
    </v-dialog>
    <!-- ADJUSTMENT DIALOG -->
    <v-dialog
      lazy
      v-model="adjustmentDialog"
      max-width="700px"
      @keydown.esc="adjustmentDialog = false"
    >
      <add-adjustment
        @close="adjustmentDialog = false"
        :project="rcti.project"
        :subject="rcti.contractor"
      ></add-adjustment>
    </v-dialog>
    <!--DELETE PROMPT DIALOG -->
    <v-dialog lazy v-model="deleteDialog" max-width="700px" @keydown.esc="adjustmentDialog = false">
      <invoice-delete-prompt
        @close="deleteDialog = false"
        :invoice="rcti"
        invoiceType="rcti"
        text="Delete RCTI"
      ></invoice-delete-prompt>
    </v-dialog>
  </tr>
</template>

<script>
import EditRcti from "@/components/rctis/editRcti";
import AddAdjustment from "@/modules/adjustments/addAdjustment";
import FormatDates from "@/services/mixins/formatDates";
import Store from "@/store/computed/storeHelpers";
import RctiService from "@/services/requests/rctiService";
import InvoiceDeletePrompt from "./invoiceDeletePrompt";
import CreatedUpdatedRows from "@/services/mixins/createdUpdatedRows";
import RowDisplayMethods from "@/services/mixins/rowDisplayMethods";
export default {
  mixins: [FormatDates, CreatedUpdatedRows, RowDisplayMethods],
  data() {
    return {
      prefix: "rcti",
      editDialog: false,
      detailDialog: false,
      actionConfirmationDialog: false,
      summaryDialog: false,
      actionsMenu: false,
      currentNotes: "",
      fieldData: {},
      adjustmentDialog: false,
      deleteDialog: false
    };
  },
  methods: {
    actionComplete() {
      this.fieldData = {};
      this.actionConfirmationDialog = false;
    },
    editRcti() {
      this.editDialog = true;
    },
    addAdjustment() {
      this.adjustmentDialog = true;
    },
    deleteRcti() {
      this.deleteDialog = true;
    },
    viewSummaryDialog() {
      this.summaryDialog = true;
    },
    confirmUpdateRctiField(payload) {
      this.fieldData = payload;
      this.currentNotes = this.rcti[payload.notesField];
      this.actionConfirmationDialog = true;
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", { value: val, object: this.rcti });
      }
    },
    credit() {
      return Number(this.rcti.total) < 0;
    },
    closed() {
      return this.rcti.status == "CLOSED";
    },
    approved() {
      return this.rcti.status == "APPROVED";
    },
    sent() {
      return this.rcti.status == "SENT";
    }
  },
  props: {
    rcti: Object,
    headers: Array,
    value: Boolean
  },
  components: {
    EditRcti,
    AddAdjustment,
    InvoiceDeletePrompt
  }
};
</script>

<style>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}

.approved-border {
  border-left: solid rgb(63, 81, 181) 6px !important;
  border-left-color: rgb(63, 81, 181) !important;
}
.sent-border {
  border-left: solid #4caf50 6px !important;
  border-left-color: #4caf50 !important;
}
</style>
